export interface Location {
  id: number;
  company_name: string;
  city: string;
  street: string;
  zip: number;
  country: string;
}

export const countries = [
  { title: 'Deutschland', shortTitle: 'DEU' },
  { title: 'Belgien', shortTitle: 'BEL' },
  { title: 'Dänemark', shortTitle: 'DNK' },
  { title: 'Frankreich', shortTitle: 'FRA' },
  { title: 'Italien', shortTitle: 'ITA' },
  { title: 'Luxemburg', shortTitle: 'LUX' },
  { title: 'Niederlande', shortTitle: 'NLD' },
  { title: 'Österreich', shortTitle: 'AUT' },
  { title: 'Polen', shortTitle: 'POL' },
  { title: 'Portugal', shortTitle: 'PRT' },
  { title: 'Schweiz', shortTitle: 'CHE' },
  { title: 'Spanien', shortTitle: 'ESP' },
  { title: 'Tschechien', shortTitle: 'CZE' },
];
